<template>
  <div>
    <el-tabs v-model="activeName" tab-position="left" class="XJTab">
      <el-tab-pane v-for="(item, index) in XJList" :key="index" :label="item.name" :name="item.name">
        <el-row>
          <div class="contentTitle"
               style="color: #ee7a18; font-size: 36px; padding: 20px 100px">
            {{that.$root.language == 1?item.textName:item.textName_en}}
          </div>
          <div class="content" style="padding: 20px 100px">
            <div class="top" style="padding-bottom: 20px; font-size: 24px">
              {{that.$root.language == 1?'1、产品概述':'1. GENERAL DESCRIPTION'}}
            </div>
            <div v-show="item.description1" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description1:item.description1_en}}
            </div>
            <div v-show="item.description2" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description2:item.description2_en}}
            </div>
            <div v-show="item.description3" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description3:item.description3_en}}
            </div>
            <div v-show="item.description4" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description4:item.description4_en}}
            </div>
            <div v-show="item.description5" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description5:item.description5_en}}
            </div>
            <div v-show="item.description6" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description6:item.description6_en}}
            </div>
            <div v-show="item.description7" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description7:item.description7_en}}
            </div>
            <div class="center" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'2、产品指标':'2、PRODUCT INDEX'}}
            </div>
            <img v-if="that.$root.language == 1" v-show="item.img1" :src="item.img1"
                 style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img1" :src="item.img1_en"
                 style="width: 100%" />
            <div class="bottom" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'3、应用性能比较':'3、TECHNICAL DATA'}}
            </div>
            <div v-show="item.compare1" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare1:item.compare1_en}}</div>
            <div v-show="item.compare2" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare2:item.compare2_en}}</div>
            <div v-show="item.compare3" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare3:item.compare3_en}}</div>
            <div v-show="item.compare4" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare4:item.compare4_en}}</div>
            <div v-show="item.compare5" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare5:item.compare5_en}}</div>
            <div v-show="item.compare6" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare6:item.compare6_en}}</div>
            <img v-if="that.$root.language == 1" v-show="item.img2" :src="item.img2" style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img2" :src="item.img2_en" style="width: 100%" />
            <div class="remark">
              <div v-show="item.remark1" class="remarkFir" style="padding: 10px 0"> {{that.$root.language == 1?item.remark1:item.remark1_en}}</div>
              <div v-show="item.remark2" class="remarkSec" style="padding: 10px 0">{{that.$root.language == 1?item.remark2:item.remark2_en}}</div>
              <div v-show="item.remark3" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark3:item.remark3_en}}</div>
              <div v-show="item.remark4" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark4:item.remark4_en}}</div>
              <div v-show="item.remark5" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark5:item.remark5_en}}</div>
              <div v-show="item.remark6" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark6:item.remark6_en}}</div>
              <div v-show="item.remark7" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark7:item.remark7_en}}</div>
            </div>
            <div class="fourth" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'4、产品供应':'4、PRODUCT SUPPLY'}}
            </div>
            <div v-show="item.pack1" style="padding: 10px 0">{{that.$root.language == 1?item.pack1:item.pack1_en}}</div>
            <div v-show="item.pack2" style="padding: 10px 0">{{that.$root.language == 1?item.pack2:item.pack2_en}}</div>
            <div v-show="item.pack3" style="padding: 10px 0">{{that.$root.language == 1?item.pack3:item.pack3_en}}</div>
            <div v-show="item.pack4" style="padding: 10px 0">{{that.$root.language == 1?item.pack4:item.pack4_en}}</div>
          </div>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      that:this,
      activeName: 'AL12X1',
      XJList: [
        {
          name: "AL12X1",
          textName: 'AL12X1特种炭黑',
          textName_en: 'AL12X1 SPECIAL CARBON BLACK',
          description1: 'AL12X1 炭黑是安仑化工开发的一款低滞后炭黑，采用独特工艺对炭黑的形貌（比表面积、结\n' +
                        '构和聚集体尺寸分布）和表面特性进行一系列优化。与GB N234炭黑相比，在相同混炼工艺下，\n' +
                        'AL12X1 具有更好的分散性能，压出胎面的尺寸稳定性更好；AL12X1的高结构特性带来较高的门\n' +
                        '尼黏度、硬度和定伸应力，可适当降低配方中炭黑用量；AL12X1 具有较低的滞后损失，特别是与\n' +
                        '白炭黑并用可明显降低轮胎的滚动阻力，提高燃油经济性，同时不损失耐磨性能。',
          description1_en: 'AL12X1 carbon black is a low-hysteresis carbon black developed by Anlun Chemical. Anlun uses a \n' +
                          'unique process to optimize the morphology (specific surface area, structure and aggregate size \n' +
                          'distribution) and surface characteristics of carbon black. AL12X1 has the same dispersion level as \n' +
                          'N234, but a low die swell of tread extrudate. This product can endow the tread compound with low \n' +
                          'rolling resistance without loss of wear resistance.',
          description2: '本产品的典型应用：具有低滚动阻力要求的乘用车轮胎和卡客车轮胎胎面',
          description2_en: 'AL12X1 is mainly used for PCR and TBR tread compound with low rolling resistance requirements. It \n' +
                          'can be used alone or in combination with precipitated Silica.',
          remark1: '* 测试配方：天然橡胶 100 份，炭黑 50 份',
          remark1_en: 'Recipe: Natural Rubber 100 phr, Carbon Black 50 phr.',
          remark2: '以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark2_en: 'The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/AL12X1-1.png"),
          img1_en: require("../../assets/img/luntai/AL12X1-1-EN.png"),
          img2: require("../../assets/img/luntai/AL12X1-2.png"),
          img2_en: require("../../assets/img/luntai/AL12X1-2-EN.png"),
        },
        {
          name: "N110",
          textName: 'N110炭黑',
          textName_en: 'N110 CARBON BLACK',
          description1: 'N110炭黑是一款超耐磨炉黑，可赋予硫化胶优异的抗撕裂、抗\n' +
                        '切割和抗崩花掉块性能，同时胶料具有良好的耐磨性能。N110 炭黑\n' +
                        '比表面积较高、结构相对较低，因此需要优化生产工艺来获得最佳分散。',
          description1_en: 'N110 carbon black belongs to super abrasion-resistance furnace \n' +
                          'family, which is often used in tire applications requiring excellent \n' +
                          'tear resistance and cutting/cracking resistance. Rubber compounds \n' +
                          'produced with N110 also demonstrate good wear resistance in \n' +
                          'tread applications. N110 carbon black has high specific surface area \n' +
                          'and relatively low structure, so careful processing is required to \n' +
                          'obtain optimal dispersion.',
          description2: '在工业橡胶制品中，N110炭黑也适用于传送带、实心轮胎和需要优异的抗切割/抗崩花掉块性能的橡胶制品。',
          description2_en: 'In industrial rubber goods, N110 carbon black is recommended for \n' +
                          'conveyor belts, selected solid tires, and other products requiring \n' +
                          'excellent cut resistance.',
          description3: '本产品的典型应用：',
          description3_en: 'Typical application of this product:',
          description4: '非铺装路面用轮胎（OTR）胎面',
          description4_en: ' Off-the-road (OTR) tire treads',
          description5: '卡车轮胎胎面',
          description5_en: ' Truck tire treads',
          description6: '实心轮胎、传送带',
          description6_en: ' Conveyor belts',
          remark1: '测试配方：天然橡胶 100 份，炭黑 50 份，氧化锌 5 份，硬脂酸 3 份、硫黄 2.5 份、',
          remark1_en: 'Evaluation Recipe: NR 100 phr, ZnO 5 phr, Stearic Acid 3 phr, Sulfur 2.5 phr, carbon black 50 phr.',
          remark2: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark2_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N110-1.png"),
          img1_en: require("../../assets/img/luntai/N110-1-EN.png"),
          img2: require("../../assets/img/luntai/N110-2.png"),
          img2_en: require("../../assets/img/luntai/N110-2-EN.png"),
        },
        {
          name: "N115",
          textName: 'N115炭黑',
          textName_en: 'N115 CARBON BLACK',
          description1: 'N115 是一款超耐磨炭黑，可赋予天然橡胶、合成橡胶良好的补\n' +
                        '强性能，填充硫化胶具有高的抗拉强度、撕裂强度和耐磨性，兼具相\n' +
                        '对适中的模量和回弹性。N115炭黑具有较高的比表面积和相对较低\n' +
                        '的结构，因此需要优化混炼工艺来获得最佳分散。',
          description1_en: 'N115 carbon black belongs to super abrasion-resistance furnace \n' +
                          'black family, which can give natural rubber and synthetic rubber \n' +
                          'better reinforcement performance. \n' +
                          'Vulcanized rubber compounds containing N115 carbon black have \n' +
                          'very high tensile strength, tear strength and abrasion resistance, \n' +
                          'coupled with relatively low modulus and resilience. N115 carbon \n' +
                          'black has a high surface area and a relatively low structure, so \n' +
                          'careful processing is required to obtain optimal dispersion.',
          description2: '本产品的典型应用：',
          description2_en: 'Typical applications of this product:',
          description3: '非铺装路面用轮胎（OTR）胎面',
          description3_en: ' Off The Road (OTR) tire tread',
          description4: '卡车轮胎胎面',
          description4_en: ' Truck tire tread',
          description5: '航空轮胎胎面',
          description5_en: ' Aircraft tire tread',
          remark1: '*测试配方：NR 100 phr 、 CB 50 phr。',
          remark1_en: 'Evaluation Recipe: NR 100 phr, Carbon Black 50 phr',
          remark2: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark2_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N115-1.png"),
          img1_en: require("../../assets/img/luntai/N115-1-EN.png"),
          img2: require("../../assets/img/luntai/N115-2.png"),
          img2_en: require("../../assets/img/luntai/N115-2-EN.png"),
        },
        {
          name: "N121",
          textName: 'N121炭黑',
          textName_en: 'N121 CARBON BLACK',
          description1: 'N121 炭黑是一款新工艺高结构超耐磨炉黑。N121具有与GB N234炭黑相似的比表面积但更高\n' +
                        '的结构，可赋予天然橡胶和合成橡胶优异的补强性和耐磨性能，适用于乘用车、轻型卡车、重型\n' +
                        '卡车胎的胎面等。N121用于胎面配方中，具有与GB N234相似的耐磨性能，但胎面胶具有较低的滞后损失。',
          description1_en: 'N121 carbon black is a super abrasion-resistance furnace black with high structure by new \n' +
                          'technology, offering high reinforcement and abrasion resistance in natural and synthetic rubber \n' +
                          'compounds, which is applicable to the tread of passenger cars, light trucks and heavy trucks. With \n' +
                          'the similar surface area as GB N234, N121 will provide the same level of tread wear and low hysteresis.',
          description2: '该产品的典型应用：',
          description2_en: 'In the low rolling resistance truck tire tread containing silica, N121 carbon black increases the stiffness \n' +
                            'and modulus of the compound, compensating for silica\'s lower reinforcement performance and \n' +
                            'enhancing the abrasion resistance of the final compound. N121 is recommended to blend with silica \n' +
                            'in high-performance passenger car tread compound, and its high rigidity enhances the handling and \n' +
                            'wear resistance of the tire.',
          description3: '单独或与白炭黑并于低滚动阻力卡车胎面胶',
          description3_en: ' ',
          description4: '单独或与白炭黑并于高性能乘用车胎面胶',
          description4_en: ' ',
          remark1: '*测试配方：天然橡胶 100 份，炭黑 50 份',
          remark1_en: 'Evaluation Recipe: NR 100 phr, Carbon Black 50 phr',
          remark2: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark2_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N121-1.png"),
          img1_en: require("../../assets/img/luntai/N121-1-EN.png"),
          img2: require("../../assets/img/luntai/N121-2.png"),
          img2_en: require("../../assets/img/luntai/N121-2-EN.png"),
        },
        {
          name: "N134",
          textName: 'N134炭黑',
          textName_en: 'N134 CARBON BLACK',
          description1: 'N134 炭黑是一款超耐磨炉黑，可赋予天然橡胶和合成橡胶优异的补强性和耐磨性能，适用于\n' +
                        '要求高耐磨性能的卡客车轮胎胎面。相比GB N234 炭黑，N134 炭黑的耐磨性能提高10%以上。\n' +
                        'N134 炭黑也可以与白炭黑共混，用于卡车胎和高性能乘用车轮胎胎面，在保证胎面耐磨性能的情\n' +
                        '况下降低轮胎的滚动阻力。N134 炭黑在轮胎胎面胶中表现出高刚度和损耗模量，为轮胎带来良好\n' +
                        '的操控性和干地抓着力。',
          description1_en: 'N134 carbon black belongs to super abrasion-resistance furnace black, offering high reinforcement \n' +
                          'and very high resistance to abrasion in natural and synthetic rubber compounds, which is well suited \n' +
                          'for truck and bus tires subjected to high abrasion conditions. N134 carbon black can improve the \n' +
                          'abrasion resistance of rubber by above 10% compared with GB N234. N134 carbon black is also \n' +
                          'recommended to blend with silica in tread compounds of low rolling resistance truck tires to help \n' +
                          'maintain tread wear resistance. The N134 carbon black rubber compound properties of good wear, \n' +
                          'resistance to tear, cut, and chip & chunking make it very suitable for use in the treads of OTR tires, \n' +
                          'including giant earth mover and mining tires.',
          description2: '本产品的典型应用：',
          description2_en: 'Typical applications of this product:',
          description3: '卡客车轮胎胎面和乘用车轮胎胎面',
          description3_en: ' Treads of passenger, truck and OTR tires',
          description4: '非铺装路面用轮胎（OTR）胎面',
          description4_en: ' High performance passenger and light truck tires',
          description5: '卡车翻新轮胎胎面',
          description5_en: ' Truck tire re-treads',
          remark1: '* 测试配方：天然橡胶100 份、炭黑 50 份',
          remark1_en: 'Evaluation Recipe: NR 100 phr, Carbon Black 50 phr',
          remark2: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark2_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N134-1.png"),
          img1_en: require("../../assets/img/luntai/N134-1-EN.png"),
          img2: require("../../assets/img/luntai/N134-2.png"),
          img2_en: require("../../assets/img/luntai/N134-2-EN.png"),
        },
        {
          name: "N220",
          textName: 'N220炭黑',
          textName_en: 'N220 CARBON BLACK',
          description1: 'N220炭黑是一款高定伸中超耐磨炉黑，也是许多轮胎应用\n' +
                        '的行业标准，通常用作评价其它炭黑耐磨性能的基准。与GB \n' +
                        'N300 型炭黑相比，N220具有更好的耐磨、抗撕裂和抗切割性\n' +
                        '能；与GB N234炭黑相比，N220更易于分散且具有较低的滞后损失。',
          description1_en: 'N220 carbon black is an intermediate super abrasion-resistance \n' +
                          'furnace with high modulus, and is the industry standard for many \n' +
                          'tire applications, and is usually used as the benchmark for tread wear \n' +
                          'test with other carbon black. \n' +
                          'Compared with GB N300 carbon black, N220 carbon black is very \n' +
                          'suitable for tire tread that requires better wear resistance, tear \n' +
                          'resistance and cutting resistance. Compared with GB N234, N220 \n' +
                          'carbon black is easy to disperse, and the vulcanized has low \n' +
                          'hysteresis.',
          description2: '本产品的典型应用：',
          description2_en: 'Typical application of this product:',
          description3: '卡车和越野轮胎的胎面',
          description3_en: '  Treads of truck and off-the-road (OTR) tires',
          description4: '乘用车轮胎胎面',
          description4_en: '  Passenger tire treads',
          description5: '实心轮胎',
          description5_en: '  Solid tires, conveyor belts, molded components',
          description6: '传送带、模压制品',
          description6_en: ' ',
          remark1: '*测试配方：SBR 1712 89.4 份，BR 35 份，炭黑 75 份，填充油 10份',
          remark1_en: 'Evaluation Recipe: SBR 1712 89.4 phr, BR 35 phr, Carbon Black 75 phr, Extender Oil 10 phr',
          remark2: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark2_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N220-1.png"),
          img1_en: require("../../assets/img/luntai/N220-1-EN.png"),
          img2: require("../../assets/img/luntai/N220-2.png"),
          img2_en: require("../../assets/img/luntai/N220-2-EN.png"),
        },
        {
          name: "N234",
          textName: 'N234炭黑',
          textName_en: 'N234 CARBON BLACK',
          description1: 'N234 炭黑是一款新工艺高结构中超耐磨炉黑。与GB N220 \n' +
                        '炭黑相比，N234具有更高的比表面积和结构，所以分散略难，\n' +
                        '硫化胶具有略高的滞后损失，但胎面胶耐磨性能提高10%左右。',
          description1_en: 'N234 carbon black is an intermediate super abrasion-resistance furnace black with high structure by \n' +
                          'new technology. Compared with GB N220 carbon black, N234 is not easy to disperse due to its high \n' +
                          'specific surface, and vulcanizate’s behaves a high hysteresis as well. Careful mixing is required to \n' +
                          'obtain optimal dispersion as well as downstream tread extrusion. Tread wear resistance of N234 \n' +
                          'compound is about 10% higher than that of GB N220.',
          description2: 'N234炭黑特别适用于需要出色耐磨性的合成橡胶和天然橡\n' +
                        '胶胎面，也用于传送带、实心胎和其他需要较好耐磨性能的工业\n' +
                        '橡胶制品。',
          description2_en: 'N234 carbon black is especially suitable for synthetic rubber and natural rubber tread that need \n' +
                            'excellent wear resistance. It is also recommended for conveyor belt, solid tire and other industrial \n' +
                            'rubber products requiring excellent wear resistance.',
          description3: '本产品的典型应用：',
          description3_en: 'Typical applications of this product',
          description4: '乘用车、卡车和实心轮胎的胎面',
          description4_en: 'Treads of premium passenger car tires, truck tires and solid tires',
          description5: '卡车翻新轮胎胎面',
          description5_en: 'Truck tire re-treads',
          description6: '输送带',
          description6_en: 'Conveyor belts',
          remark1: '*测试配方：SBR 1712 89.4 份，BR 35 份，炭黑 75 份，填充油 11 份',
          remark1_en: 'Evaluation Recipe: SBR 1712 89.4 phr, BR 35 phr, Carbon Black 75 phr, Extender Oil 10 phr',
          remark2: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark2_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N234-1.png"),
          img1_en: require("../../assets/img/luntai/N234-1-EN.png"),
          img2: require("../../assets/img/luntai/N234-2.png"),
          img2_en: require("../../assets/img/luntai/N234-2-EN.png"),
        },
        {
          name: "N326",
          textName: 'N326炭黑',
          textName_en: 'N326 CARBON BLACK',
          description1: 'N326是一款低结构高耐磨炉黑，比表面积与N330相似，但结构更低。与GB N330相比，硫化\n' +
                        '胶的定伸应力低，扯断伸长率高，拉伸强度基本一致。N326广泛应用于子午线轮胎钢丝帘布胶、\n' +
                        '橡胶工业制品、输送带、塑料色母粒等行业。',
          description1_en: 'N326 carbon black is a high abrasion-resistance furnace black with low structure. It’s specific surface \n' +
                          'area is similar to N330, but its structural degree is lower. Compared with N330, the rubber compound \n' +
                          'has lower Mooney viscosity, lower constant elongation stress, higher elongation at break, lower heat \n' +
                          'generation, similar tensile strength and poor dispersion. As a large amount of carbon black, N326 is \n' +
                          'widely used in tire, rubber industrial products, tires, conveyor belts, color masterbatches and other \n' +
                          'industries.',
          description2: ' ',
          description2_en: 'Typical applications of this product:',
          description3: ' ',
          description3_en: ' Belt skim and carcass ply coating compounds of passenger, truck and OTR tires',
          description4: ' ',
          description4_en: ' Rubber coatings compound of steel wire and fabric layers in various hoses and belts',
          remark1: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N326-1.png"),
          img1_en: require("../../assets/img/luntai/N326-1-EN.png"),
          img2: require("../../assets/img/luntai/N326-2.png"),
          img2_en: require("../../assets/img/luntai/N326-2-EN.png"),
        },
        {
          name: "N330",
          textName: 'N330炭黑',
          textName_en: 'N330 CARBON BLACK',
          description1: 'N330是一款高耐磨炉黑，具有中等的比表面积和结构，对胶料具有中等的补强性能，耐磨性\n' +
                        '能相比GB N220低8～10%。N330是炭黑行业产销量最大的品种之一，广泛应用于轮胎、输送带、胶管等工业橡胶制品领域。',
          description1_en: 'N330 carbon black is a high abrasion-resistance furnace black, whose reinforcing performance is \n' +
                            'better than that of semi-reinforcing product and wear resistance is worse by 8-10% than that of GB \n' +
                            'N220. As an industry standard for many applications, N330 is widely used in tire application, rubber \n' +
                            'industrial products, including conveyor belt, rubber hose and other product requiring moderate \n' +
                            'abrasion resistance.',
          remark1: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N330-1.png"),
          img1_en: require("../../assets/img/luntai/N330-1-EN.png"),
          img2: require("../../assets/img/luntai/N330-2.png"),
          img2_en: require("../../assets/img/luntai/N330-2-EN.png"),
        },
        {
          name: "N339",
          textName: 'N339炭黑',
          textName_en: 'N339 CARBON BLACK',
          description1: 'N339炭黑是一款新工艺高结构高耐磨炉黑。与N330炭黑相比，N339的比表面积较大，结构较高，硫化胶的耐磨性能、抗撕裂性能接近于GB N220炭黑。',
          description1_en: 'N339 is a high abrasion-resistance furnace black with high structure by new technology. Compared \n' +
                          'with N330, this product has high structure which gives it easy dispersion properties, and it gives \n' +
                          'moderately high modulus. The abrasion resistance of the rubber compound is superior to the same \n' +
                          'product produced by traditional process, and close to N220.',
          description2: 'N339广泛应用于乘用车、卡车胎胎面胶、输送带覆盖胶、胶管、橡胶制品等行业。',
          description2_en: 'N339 is widely used in passenger cars, truck tread rubber, conveyor belt covering rubber, rubber hose, rubber products and other industries.',
          remark1: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N339-1.png"),
          img1_en: require("../../assets/img/luntai/N339-1-EN.png"),
          img2: require("../../assets/img/luntai/N339-2.png"),
          img2_en: require("../../assets/img/luntai/N339-2-EN.png"),
        },
        {
          name: "N347",
          textName: 'N347炭黑',
          textName_en: 'N347 CARBON BLACK',
          description1: 'N347炭黑是一款高结构高耐磨炉黑。与GB N330相比，N347具有更高的比表面积和略低的结构，硫化胶的耐磨性能和抗崩花、耐切割性能均较好。',
          description1_en: 'N347 carbon black is a high abrasion-resistance with high structure, providing a easier dispersion \n' +
                          'and extrusion than GB N375 and N339 carbon blacks. N347 is well-suited for tire treads that require \n' +
                          'medium to good wear resistance with low hysteresis.',
          description2: '本产品的典型应用：',
          description2_en: 'N347 is applicable to passenger car tires, truck and bus tires, conveyor belts, rubber hoses, rubber \n' +
                          'products and other industries.',
          description3: '非铺装路面用轮胎（OTR）胎面',
          description3_en: ' ',
          description4: '输送带、胶管等工业橡胶制品',
          description4_en: ' ',
          remark1: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N347-1.png"),
          img1_en: require("../../assets/img/luntai/N347-1-EN.png"),
          img2: require("../../assets/img/luntai/N347-2.png"),
          img2_en: require("../../assets/img/luntai/N347-2-EN.png"),
        },
        {
          name: "N351",
          textName: 'N351炭黑',
          textName_en: 'N351 CARBON BLACK',
          description1: 'N351是一款新工艺高结构高耐磨炉黑。在GB N300系列炭黑产品中，N351的粒径最大，结构\n' +
                        '较高。与N330炭黑相比，N351更易于分散，加工性能良好；硫化胶的定伸应力略高，但生热低、\n' +
                        '动态性能好；耐磨性能与N330相似。N351广泛应用于乘用车轮胎、卡客车轮胎、输送带、胶管、\n' +
                        '橡胶制品等行业。',
          description1_en: 'N351 carbon black is high abrasion-resistance furnace with high structure by new technology. In \n' +
                          'N300 series, N351 has the lowest surface area but a high structure. N351 vulcanizate is similar to \n' +
                          'N330 in in terms of processability, heat generation, dynamic mechanical performance, high \n' +
                          'elongation stress, and wear resistance. N351 is widely used in passenger car tyres, truck and bus tyres, \n' +
                          'conveyor belts, rubber hoses, rubber products and other industries.',
          remark1: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N351-1.png"),
          img1_en: require("../../assets/img/luntai/N351-1-EN.png"),
          img2: require("../../assets/img/luntai/N351-2.png"),
          img2_en: require("../../assets/img/luntai/N351-2-EN.png"),
        },
        {
          name: "N375",
          textName: 'N375炭黑',
          textName_en: 'N375 CARBON BLACK',
          description1: 'N375是一款新工艺高结构高耐磨炉黑。与GB N330相比，N375具有更高的比表面积和结构，\n' +
                          '可赋予硫化胶更好的补强性能。N375的补强性能稍逊于N339，但滞后损失和生热略低。N375广\n' +
                          '泛应用于乘用车轮胎胎面、卡客车轮胎胎体、输送带覆盖胶、胶管、橡胶制品等行业。',
          description1_en: 'N375 carbon black is a high abrasion-resistance furnace black with high structure by new technology. \n' +
                          'Its structure is slightly lower than that of N339. The curing heat generation of N375 is slightly lower, \n' +
                          'and other properties are close to that of N339. N375 is widely used in passenger car tyres, truck and \n' +
                          'bus tyres, conveyor belt covering rubber, rubber hose, rubber products and other industries.',
          remark1: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N375-1.png"),
          img1_en: require("../../assets/img/luntai/N375-1-EN.png"),
          img2: require("../../assets/img/luntai/N375-2.png"),
          img2_en: require("../../assets/img/luntai/N375-2-EN.png"),
        },
        {
          name: "N550",
          textName: 'N550炭黑',
          textName_en: 'N550 CARBON BLACK',
          description1: 'N550炭黑是一款快压出炉黑，比表面积低，结构高，易于分散。N550炭黑赋予胶料较高的挺\n' +
                        '性，挤出制品的口型膨胀小，表面光滑。N550的补强性能高于其他软质炭黑N600和N700系列。\n' +
                        'N550适用于天然橡胶和多种合成橡胶，常用于轮胎胎侧、内胎等挤出和模压制品。',
          description1_en: 'N550 carbon black is a fast extrusion furnace black with low surface area combined high structure, \n' +
                          'which is easy to disperse. N550 can give the compound high stiffness, fast extrusion speed, small die \n' +
                          'swell, and smooth extrudate surface. Its reinforcing performance is higher than other reinforcing product of N600 and N700 series. N550 is widely used in natural rubber and synthetic \n' +
                          'rubber matrix, including tire sidewall, inner tube application.',
          remark1: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N550-1.png"),
          img1_en: require("../../assets/img/luntai/N550-1-EN.png"),
          img2: require("../../assets/img/luntai/N550-2.png"),
          img2_en: require("../../assets/img/luntai/N550-2-EN.png"),
        },
        {
          name: "N660",
          textName: 'N660炭黑',
          textName_en: 'N660 CARBON BLACK',
          description1: 'N660是一款通用炉黑，与半补强炉黑相比，比表面积较大，结构较高。N660在胶料中易分散，\n' +
                        '硫化胶的生热低，弹性好，耐屈挠。N660适用于天然橡胶和多种合成橡胶，广泛应用于轮胎胎体、\n' +
                        '气密层、内胎、胶管、胶带等压延、挤出和模压胶橡胶制品。',
          description1_en: 'N660 is a general purpose furnace black. Compared with semi-reinforced furnace black, its structure \n' +
                          'is higher, its particles are slightly finer, and it is easy to disperse in the rubber compound. The \n' +
                          'vulcanizate has low heat build-up, good resilience and flexing resistance. N660 is applicable to \n' +
                          'natural rubber and a variety of synthetic rubber. It is widely used for tire carcass, cord fabric, inner \n' +
                          'tube, rubber tube, tape, etc.',
          remark1: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N660-1.png"),
          img1_en: require("../../assets/img/luntai/N660-1-EN.png"),
          img2: require("../../assets/img/luntai/N660-2.png"),
          img2_en: require("../../assets/img/luntai/N660-2-EN.png"),
        },
        {
          name: "N774",
          textName: 'N774炭黑',
          textName_en: 'N774 CARBON BLACK',
          description1: 'N774炭黑是一款非污染低定伸半补强炉黑，可大量填充于橡胶中，其混炼胶粘度较低，加工\n' +
                        '生热小；硫化胶的弹性高，动态性能好；相比GB N550炭黑，挤出性能稍差。N774多用于轮胎帘\n' +
                        '布、气密层、内胎、胶管、胶带、密封件、垫圈、雨刷器、减震制品等工业橡胶制品。',
          description1_en: 'N774 is a semi-reinforcing furnace black with low modulus and non-contamination, which can be \n' +
                          'filled in a large amount in rubber. N774 compound has low Mooney viscosity and processing heat \n' +
                          'built-up, its vulcanizate has high resilience and excellent dynamic performance. The extrusion \n' +
                          'performance is poor than that of GB N550. N774 is mainly used for rubber industrial products such \n' +
                          'as tire cord, inner liner, inner tube, rubber hose, tape, seal, gasket, wiper, anti-vibration, etc.',
          remark1: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/N774-1.png"),
          img1_en: require("../../assets/img/luntai/N774-1-EN.png"),
          img2: require("../../assets/img/luntai/N774-2.png"),
          img2_en: require("../../assets/img/luntai/N774-2-EN.png"),
        },
        {
          name: "非标N134",
          textName: '非标N134炭黑',
          textName_en: 'NONSTD N134 Carbon black',
          description1: '安仑非标N134 是一款超耐磨炭黑。与GB N134炭黑相比，非标N134具有相近的粒径尺寸，氮\n' +
                        '吸附表面积和着色强度稍低，因此更加容易分散；填充硫化胶具有较高的回弹性和较低的滞后损\n' +
                        '失。与GB N234 和GB N115相比，非标N134 炭黑具有更好的耐磨性能，被广泛应用于耐磨性能要\n' +
                        '求更高的轮胎胎面胶中。',
          description1_en: 'NONSTD AL134 is a super abrasion-resistance furnace black launched by Anlun Chemical. Compared \n' +
                            'with GB N134 carbon black, it has similar particle size, but the nitrogen absorption surface area and \n' +
                            'Tint strength are slightly lower. NONSTD N134 is easier to disperse than that of GB N134, and its \n' +
                            'vulcanizate has high resilience and low hysteresis.',
          description2: '该产品的典型应用：',
          description2_en: 'AL134 carbon black is widely used in high-performance tire tread compound because of its low heat \n' +
                            'bulit-up, easy dispersion and excellent wear resistance. Its vulcanizate has good wear resistance, tear \n' +
                            'resistance and cutting resistance, and is mainly used in:',
          description3: '卡客车轮胎、乘用车轮胎胎面',
          description3_en: 'Treads of passenger cars, trucks and OTR tyres',
          description4: '卡车翻新轮胎胎面',
          description4_en: 'Truck retreaded tire tread',
          remark1: '* 测试配方：天然胶 100 份、炭黑 50 份',
          remark1_en: 'Evaluation Recipe: NR 100 phr, Carbon Black 50 phr',
          remark2: '* 以上典型数据仅供参考，配方、工艺等或有差异需依实际情况而定。',
          remark2_en: '* The data above are typical test values intended as guidance only.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 500kg FIBC; 1,000kg FIBC',
          img1: require("../../assets/img/luntai/feibiaoN134-1.png"),
          img1_en: require("../../assets/img/luntai/feibiaoN134-1-EN.png"),
          img2: require("../../assets/img/luntai/feibiaoN134-2.png"),
          img2_en: require("../../assets/img/luntai/feibiaoN134-2-EN.png"),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
  width: 150px;
}
::v-deep .el-tabs__item.is-active {
  background-color: rgba($color: #000000, $alpha: 0.1);
}
::v-deep .el-tabs__nav{
  background-color: #ffffff !important;
  color: #000000 !important;
}
::v-deep .el-tabs__item.is-active {
  color: #ee7a18 !important;
}
::v-deep .el-tabs__item:hover {
  color: #ee7a18 !important;
  cursor: pointer !important;
}
::v-deep .el-tabs__item.is-left{
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
//::v-deep [id^="tab-AL"]{
//  text-align: center;
//  height: 50px;
//  font-size: 16px;
//  line-height: 50px;
//}
</style>